// register click event for links that close Cart modal
const ITEM_DETAIL_ADD_TO_CART_SECTION_CLASSNAME = "js-item-detail-add-to-cart-section";
const ITEM_DETAIL_PURCHASE_EXCEED_SECTION_CLASSNAME = "js-item-detail-purchase-exceed-section";
const ITEM_DETAIL_SOLD_OUT_SECTION_CLASSNAME = "js-item-detail-sold-out-section";
const ITEM_DETAIL_CONTAINER_CLASSNAME = "js-item-detail-container";
const ADD_TO_CART_SPINNER_CLASSNAME = "js-add-to-cart-spinner";
const CART_ITEM_CLASSNAME = "js-cart-item";
const CLOSE_CART_BUTTON_CLASSNAME = "js-close-cart-button";
const ITEM_AMOUNT_CLASSNAME = "js-item-amount";
const $closeCartButtonLinks = document.querySelectorAll(`.${CLOSE_CART_BUTTON_CLASSNAME}`);

$closeCartButtonLinks.forEach(function (element) {
  element.addEventListener("click", () => {
    // if current page is Item Detail, update the add to cart section after closing Cart modal
    const bodyClass = document.body.getAttribute("class");
    if (bodyClass.indexOf("item-detail") !== -1) {
      const $itemDetailContainer = document.querySelector(`.${ITEM_DETAIL_CONTAINER_CLASSNAME}`);
      const { containerItemId } = $itemDetailContainer.dataset;
      const $cartItems = document.querySelectorAll(`.${CART_ITEM_CLASSNAME}`);

      $cartItems.forEach(function (cartItem) {
        const $cartItemAmount = cartItem.querySelector(`.${ITEM_AMOUNT_CLASSNAME}`);
        const { cartItemId, cartItemIsSoldOut } = $cartItemAmount.dataset;

        if (containerItemId === cartItemId) {
          const $itemDetailPurchaseExceedSectionElement = document.querySelector(
            `.${ITEM_DETAIL_PURCHASE_EXCEED_SECTION_CLASSNAME}`
          );
          const $itemDetailAddToCartSectionElement = document.querySelector(
            `.${ITEM_DETAIL_ADD_TO_CART_SECTION_CLASSNAME}`
          );
          const $itemDetailSoldOutSectionElement = document.querySelector(
            `.${ITEM_DETAIL_SOLD_OUT_SECTION_CLASSNAME}`
          );
          const $itemQuantityCanPurchase = $cartItemAmount.max - $cartItemAmount.value;

          if ($itemQuantityCanPurchase > 0) {
            $itemDetailAddToCartSectionElement.removeAttribute("hidden");
            $itemDetailPurchaseExceedSectionElement.setAttribute("hidden", "");
            $itemDetailSoldOutSectionElement.setAttribute("hidden", "");

            const $addToCartSpinner = document.querySelector(`.${ADD_TO_CART_SPINNER_CLASSNAME}`);
            const $addToCartItemAmount = $addToCartSpinner.querySelector(
              `.${ITEM_AMOUNT_CLASSNAME}`
            );
            const $addToCartSpinnerUp = $addToCartSpinner.querySelector(".js-spinner-up");
            const $addToCartSpinnerDown = $addToCartSpinner.querySelector(".js-spinner-down");

            $addToCartItemAmount.setAttribute("max", $itemQuantityCanPurchase.toString());
            if ($addToCartItemAmount.value > $itemQuantityCanPurchase) {
              // Set add to cart item amount value to the purchasable amount
              $addToCartItemAmount.value = $itemQuantityCanPurchase;
            }

            if ($itemQuantityCanPurchase === 1) {
              // If user able to purchase one quantity only add "is-disabled" class
              $addToCartSpinnerUp.classList.add("is-disabled");
              $addToCartSpinnerDown.classList.add("is-disabled");
            } else if (parseInt($addToCartItemAmount.value, 10) === 1) {
              $addToCartSpinnerDown.classList.add("is-disabled");
              $addToCartSpinnerUp.classList.remove("is-disabled");
            } else if (
              parseInt($addToCartItemAmount.value, 10) === parseInt($addToCartItemAmount.max, 10)
            ) {
              $addToCartSpinnerDown.classList.remove("is-disabled");
              $addToCartSpinnerUp.classList.add("is-disabled");
            } else {
              $addToCartSpinnerUp.classList.remove("is-disabled");
              $addToCartSpinnerDown.classList.remove("is-disabled");
            }
          } else {
            $itemDetailAddToCartSectionElement.setAttribute("hidden", "");
            // If $itemQuantityCanPurchase = 0 set purchase exceed or sold out section
            if (cartItemIsSoldOut === "1") {
              $itemDetailSoldOutSectionElement.removeAttribute("hidden");
              $itemDetailPurchaseExceedSectionElement.setAttribute("hidden", "");
            } else {
              $itemDetailPurchaseExceedSectionElement.removeAttribute("hidden");
              $itemDetailSoldOutSectionElement.setAttribute("hidden", "");
            }
          }
        }
      });
    }
  });
});
